import type { LucideIcon } from 'lucide-react';

type IconBadgeProps = {
  icon: LucideIcon;
  title: string;
  text?: string;
};

export function IconBadge({ icon: Icon, title, text }: IconBadgeProps) {
  return (
    <div className="icon-badge">
      <span className="icon-badge__icon"><Icon size={20} strokeWidth={1.8} /></span>
      <span>
        <strong>{title}</strong>
        {text && <small>{text}</small>}
      </span>
    </div>
  );
}
